import { ClassName } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import DashboardCard from '../DashboardCard/DashboardCard';
import DashboardCardSpinner from 'containers/dashboard/dashboard-grid/card/DashboardCardSpinner/DashboardCardSpinner';
import { DashboardTheme } from 'containers/dashboard/types/types';
import './DashboardSpinnerCard.scss';

export interface IDashboardSpinnerCardProps {
  theme: DashboardTheme;
  className?: ClassName;
}

export default function DashboardSpinnerCard({ theme, className }: IDashboardSpinnerCardProps) {
  const classes = classNames('dashboard-spinner-card', className);
  return (
    <DashboardCard className={classes} theme={theme}>
      <DashboardCardSpinner />
    </DashboardCard>
  );
}
